export * from './aufgabeTracing.service';
import { AufgabeTracingService } from './aufgabeTracing.service';
export * from './aufgabeTracingTemplates.service';
import { AufgabeTracingTemplatesService } from './aufgabeTracingTemplates.service';
export const APIS = [AufgabeTracingService, AufgabeTracingTemplatesService];
